import React, { useEffect } from "react";
import "./login.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/i18n"; 

import bfLogo from "../assets/bf_logo.png";
import lockIcon from "../assets/lock.png";

const LoginPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  const handleChangeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  return (
    <div className="login-container">
      <div className="login-card gold-glow">

        <img src={bfLogo} alt="BF Logo" className="login-logo" />
        <h1 className="login-title">BuildForce AL</h1>

        {/* Mygtukas Registruotis (BE IKONOS) */}
        <button
          className="login-btn worker-btn"
          onClick={() => navigate("/register")}
        >
          {/* PATAISYMAS: Pridėtas stilius, kad visada būtų iš didžiosios raidės */}
          <span style={{ textTransform: 'capitalize' }}>
            {t("register") || "Registrieren"}
          </span>
        </button>

        {/* Mygtukas Admin Login (Su spyna) */}
        <button
          className="login-btn admin-btn"
          onClick={() => navigate("/admin/login")}
        >
          <img src={lockIcon} className="icon-img pulse-gold" alt="Admin" />
          <span>Admin Login</span>
        </button>

        {/* Kalbos pasirinkimas (Sutvarkytas kaip mygtukas) */}
        <div className="language-wrapper">
          <select
            className="login-btn language-select-input"
            value={i18n.language}
            onChange={(e) => handleChangeLanguage(e.target.value)}
          >
            <option value="en">English</option>
            <option value="de">Deutsch</option>
            <option value="ru">Русский</option>
            <option value="lt">Lietuvių</option>
            <option value="ro">Română</option>
            <option value="bg">Български</option>
            <option value="nl">Nederlands</option>
          </select>
        </div>

      </div>
    </div>
  );
};

export default LoginPage;